import { Box, Grid } from "@mui/material";
import { useCallback, useState } from "react";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Page from "src/components/Page";
import useLocales from "src/hooks/useLocales";
import { PATH_USER } from "src/routes/paths";
import axiosInstance from "src/utils/fetchUser";
import useFetchSummary from "../hooks/useFetchSummary";
import useFetchWitPagination from "../hooks/useFetchWithPagination";
import { BreakdownByType, DataList, FilterCard } from "./components";
import Summary from "./components/summary";
import useFetchBreakdown from "./hooks/useFetchBreakdown";

const Index = () => {
  const { translate } = useLocales();
  const { data, fetchData, ...rest } = useFetchWitPagination("ewallet");
  const summary = useFetchSummary("ewallet-data");

  // Conservo l'ultimo filtro applicato: serve sia al breakdown (rifetcha
  // automaticamente quando cambia) sia all'export CSV (riusa gli stessi
  // criteri di filtraggio della tabella).
  const [activeFilter, setActiveFilter] = useState({});
  const { breakdown, total, isLoading: breakdownLoading } = useFetchBreakdown(activeFilter);

  const handleFetchData = useCallback((filter) => {
    setActiveFilter(filter);
    fetchData(rest.page, filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  // Download CSV: chiama l'endpoint backend con `responseType: 'blob'` e
  // forza il download via anchor + revokeObjectURL.
  const handleExport = useCallback(async (filter) => {
    try {
      const response = await axiosInstance.get("ewallet-export", {
        params: filter,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `ewallet_${new Date().toISOString().slice(0, 10)}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("CSV export failed", err);
    }
  }, []);

  return (
    <Page title={translate("userFinancial.eWallet.ewalletTitile")}>
      <Box sx={{ p: 2 }}>
        <HeaderBreadcrumbs
          heading={translate("userFinancial.eWallet.myEwallet")}
          links={[
            { name: translate("dashboard"), href: PATH_USER.root },
            { name: translate("userFinancial.eWallet.myEwallet") },
          ]}
        />

        <Grid container spacing={2}>
          <Summary summary={summary} />

          <Grid item xs={12}>
            <FilterCard fetchData={handleFetchData} onExport={handleExport} />
          </Grid>

          {/* Breakdown e tabella affiancate, altezza naturale per ciascuna.
              Tentativo precedente di stretch all'altezza max creava un grande
              vuoto sotto il breakdown quando la tabella era molto lunga. */}
          <Grid item xs={12} md={5}>
            <BreakdownByType breakdown={breakdown} total={total} isLoading={breakdownLoading} />
          </Grid>

          <Grid item xs={12} md={7}>
            <DataList data={data} {...rest} />
          </Grid>
        </Grid>
      </Box>
    </Page>
  );
};

export default Index;
